import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ErrorReportDialogComponent } from '@app/shared/error-report-dialog/error-report-dialog.component';
import { Labels } from '@core/constants/labels';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FloatingInfoComponent } from './shared/floating-info/floating-info.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    FloatingInfoComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'oncodata_telepathology_frontend';

  labels = Labels.BUG_REPORT;

  isLoggedIn: boolean = false;

  private routerSubscription: Subscription | undefined;

  constructor(
    private dialog: MatDialog,
    private router: Router,
  ) {}

  ngOnInit() {
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        this.isLoggedIn = !event.urlAfterRedirects.startsWith('/auth');
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  openErrorReportDialog() {
    this.dialog.open(ErrorReportDialogComponent, {
      width: '400px',
    });
  }
}
